import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import './Plans.css';
import tickCircleIcon from '../assets/images/tickCircleIcon.svg';
import { MobilePlanService } from '../Network/services/MobilePlanService';

const MobilePlans = ({ dispatch }) => {
  const [loading, setLoading] = useState(false);
  const [availablePlans, setAvailablePlans] = useState([]);
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const authToken = urlParams.get('authToken');

  useEffect(() => {
      try {
        if(authToken){
            setLoading(true);
            localStorage.setItem('authToken', authToken);
            fetchPlansData();
        } else {
            toast.error('Invalid auth token');
        }
    } catch (e) {
    }
  }, []);

  const fetchPlansData = async () => {
    setLoading(true);
    
    try {
      const payload = new FormData();
      const response = await MobilePlanService.getMobilePlansAndMyPlans(payload);
      
      if (response.status === 200) {
        const transformedPlans = response.data.plans
          .filter(plan => plan.status === "1") 
          .map(plan => ({
            id: plan.plan_id,
            name: plan.subscription_name,
            price: parseFloat(plan.price),
            currency: '₹',
            unit: 'job post',
            description: plan.description,
            features: plan.content,
            recommended: plan.is_recommended == "1",
            is_premium: plan.is_premium,
            gst_percentage: plan.gst_percentage
          }))
          .sort((a, b) => b.price - a.price);      
        
        setAvailablePlans(transformedPlans);
      } else {
        toast.error('Failed to fetch plans data');
      }
    } catch (err) {
      toast.error('Failed to fetch plans data');
    } finally {
      setLoading(false);
    }
  };

  const handleGetStarted = async (planId) => {
    
    try {
      const payload = new FormData();
      payload.append('plan_id', planId); 
      payload.append('is_web_plan_purchase', true);
      
      const response = await MobilePlanService.createMobilePaymentOrder('create_payment_order', payload);
      
      if (response.status === '200' && response.data && response.data.cashfree_order) {
        const checkoutUrl = response.data.cashfree_order.payment_link;
        window.location.href = checkoutUrl;
      } else {
        toast.error('Failed to create payment order. Please try again.');
      }
    } catch (error) {
      toast.error('Payment initialization failed. Please try again.');
    }
  };

  return (
    <div className="plans-container">
      <div className="animation-overlay"></div>
      <div className="content">
        <h1 className="title">Plans</h1>
           
          <div className="buy-plans-container">
            {loading ? (
              <div className="loading-message">
                <div className="plans-spinner"></div>
                <div>Loading plans...</div>
              </div>
            ) : availablePlans.length > 0 ? (
              availablePlans.map((plan) => (
                <div key={plan.id} className="buy-plan-card">
                  {plan.recommended && (
                    <div className="recommended-badge">RECOMMENDED</div>
                  )}
                  <div className={`buy-plan-name ${plan.is_premium === "0" || plan.is_premium === 0 ? 'lite-plan' : 'premium-plan'}`}>{plan.name}</div>
                  <div className="price-container">
                    <div className="price">{plan.currency} {plan.price}/</div>
                    <div className="price-unit"> {plan.unit}</div>
                  </div>
                  <div className='price-description-container'>
                    <p>{plan.gst_percentage}% GST will be added during payment.</p>
                  </div>
                  <button 
                    className={`get-started-button ${plan.recommended ? 'get-started-button-premium' : 'get-started-button-premium'}`}
                    onClick={() => handleGetStarted(plan.id)}
                  >
                    Get Started
                  </button>
                  <ul className="features-list">
                  <div className="buy-plan-description">
                    {plan.description}
                  </div>
                    {plan.features.map((feature, index) => (
                      <li key={index} className="feature-item">
                        <img src={tickCircleIcon} alt="check" className="check-icon" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              ))
            ) : (
              <div className="no-plans-message">No plans available</div>
            )}
          </div>
        
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

export default connect(null, mapDispatchToProps)(MobilePlans);
